import Vue from 'vue';
import Vuex from 'vuex';
import global from './modules/global';
import devices from './modules/devices';
import devicetypes from './modules/devicetypes';
import manufacturers from './modules/manufacturers';
import smartimport from './modules/smartimport';
import templates from './modules/templates';
import templatetypes from './modules/templatetypes';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    global,
    devices,
    devicetypes,
    manufacturers,
    smartimport,
    templates,
    templatetypes,
  },
});
